export default __webpack_public_path__ + "static/media/voucherAddition2.6bccedf0.jpg";